// extracted by mini-css-extract-plugin
export default {"block":"StartBlock_block__xiSRS","title":"StartBlock_title__bNv-8"};